'use client';

import axios from 'axios';
import { useState, useEffect } from 'react';
import { Box, Flex, Image, Text } from "@chakra-ui/react";
import ContentBox from "@/components/partials/ContentBox";

export default function Weather() {
  const [weather, setWeather] = useState(null);

  useEffect(() => {
    axios.get(`${process.env.NEXT_PUBLIC_API_URL}/portal/componentes/widget?name=weather`).then(response => {
      if(response && response.data && response.data.data) {
      setWeather(response.data.data);
      }
    });
  }, []);

  return (
    <ContentBox text="Previsão do Tempo" padding="0" smallText={true}>
      { weather !== null ? (
        <Box>
          <Flex justifyContent="center" alignItems="center">
            <Box maxW="80px">
              <Image src={weather.image} alt={weather.condition} />
            </Box>

            <Box fontWeight="300" fontSize="2.8em">
              { weather.temperature }º
            </Box>


          </Flex>

             <Box textAlign="center">
              <Text fontWeight="700" fontSize="1em">{ weather.city }</Text>
              <Text fontWeight="300" textTransform="uppercase" fontSize="0.8em">{ weather.condition }</Text>
            </Box>
        </Box>
        ) : (
          <Text textAlign="center" py="4">Carregando...</Text>
        )}
    </ContentBox>
  )
}
